import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import ThemeContext from '../../context/ThemeContext';

const Sidebar = ({ toggleSidebar }) => {
  const { theme } = useContext(ThemeContext);
  const whatsappLink = 'https://wa.me/989399513274';

  return (
    <div className={`sidebar ${theme} active`}>
      <button className={`close-btn ${theme}`} onClick={toggleSidebar}>
        &times;
      </button>
      <nav className="sidebar-nav">
        <ul>
          <li>
            <Link to="/" onClick={toggleSidebar} className="sidebar-link">
              Work
            </Link>
          </li>
          <li>
            
            <Link to="/about" onClick={toggleSidebar} className="sidebar-link">
              About
            </Link>
          </li>
          <li className="sidebar-cta-item">
             <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="sidebar-cta"
          >
            <span>Let's Talk</span>
            
          </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;